import { BrokerStatus } from '@insurance/types'
import { useQueryUpdate } from '@shared/hooks'
import { Flex, Select } from 'antd'
import { useTranslation } from 'react-i18next'

export const CompaniesManagementFilters = () => {
  const { t } = useTranslation()

  const { params, updateQuery } = useQueryUpdate()

  const statusOptions = Object.values(BrokerStatus).map((value) => ({
    label: t(value),
    value
  }))

  return (
    <Flex gap={8}>
      <Flex>
        <Select
          allowClear
          options={statusOptions}
          placeholder={t('status')}
          className="select-min-width"
          value={params.status}
          onChange={(status) => updateQuery({ status })}
        />
      </Flex>
    </Flex>
  )
}
